<template>
  <div class="container" :style="{ color: color, background: background }">
    <wrap-container class="w100">
      <footer>
        <p class="titulo book" v-safe-html="text"></p>
      </footer>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";

export default {
  name: "AppFooterPlanes",
  components: { WrapContainer },
  props: {
    text: String,
    color: {
      type: String,
      default: "#121212"
    },
    background: {
      type: String,
      default: "#F8F8F8"
    }
  }
};
</script>

<style scoped>
.container {
  /* color: #121212;
  background: #f8f8f8; */
  font-size: 12px;
  line-height: 1.5em;
  padding: 30px;
  margin-left: -17px;
  margin-right: -17px;
  margin-bottom: 0px;
}
.container p {
  text-align: justify;
}
</style>
